<template>
  <div class="form-container">
    <div class="card p-4">
      <h2 class="text-center mb-4">
        Registro de Festejada
      </h2>
      <form @submit.prevent="submitForm">
        <div class="mb-3">
          <label
            for="nombre"
            class="form-label"
          >Nombre</label>
          <input
            id="nombre"
            v-model="nombre_festejada"
            type="text"
            class="form-control"
            placeholder="Introduce el nombre"
          >
          <div
            v-if="errors.nombre"
            class="text-danger"
          >
            {{ errors.nombre }}
          </div>
        </div>
  
        <div class="mb-3">
          <label
            for="apellido"
            class="form-label"
          >Apellido</label>
          <input
            id="apellido"
            v-model="apellido_festejada"
            type="text"
            class="form-control"
            placeholder="Introduce el apellido"
          >
          <div
            v-if="errors.apellido"
            class="text-danger"
          >
            {{ errors.apellido }}
          </div>
        </div>
  
        <div class="mb-3">
          <label
            for="fechaevento"
            class="form-label"
          >Fecha del Evento</label>
          <input
            id="fechaevento"
            v-model="fechaevento"
            type="date"
            class="form-control"
          >
          <div
            v-if="errors.fechaevento"
            class="text-danger"
          >
            {{ errors.fechaevento }}
          </div>
        </div>
  
        <div class="mb-3">
          <label
            for="telefono"
            class="form-label"
          >Teléfono</label>
          <input
            id="telefono"
            v-model="telefono"
            type="tel"
            class="form-control"
            placeholder="Introduce el teléfono"
          >
          <div
            v-if="errors.telefono"
            class="text-danger"
          >
            {{ errors.telefono }}
          </div>
        </div>
  
        <div class="mb-3">
          <label
            for="tipo_evento"
            class="form-label"
          >Tipo de Evento</label>
          <select
            id="tipo_evento"
            v-model="tipo_evento"
            class="form-control"
          >
            <option
              value=""
              disabled
            >
              Selecciona un tipo de evento
            </option>
            <option value="boda">
              Boda
            </option>
            <option value="xv">
              XV Años
            </option>
            <option value="despedida">
              Despedida de Soltera
            </option>
            <option value="cumpleaños">
              Cumpleaños
            </option>
            <option value="otro">
              Otro
            </option>
          </select>
          <div
            v-if="errors.tipo_evento"
            class="text-danger"
          >
            {{ errors.tipo_evento }}
          </div>
        </div>
  
        <div class="mb-3">
          <label
            for="estado"
            class="form-label"
          >Estado</label>
          <select
            id="estado"
            v-model="estado"
            class="form-control"
          >
            <option
              value=""
              disabled
            >
              Selecciona un estado
            </option>
            <option
              v-for="state in estados"
              :key="state"
              :value="state"
            >
              {{ state }}
            </option>
          </select>
          <div
            v-if="errors.estado"
            class="text-danger"
          >
            {{ errors.estado }}
          </div>
        </div>
  
        <div class="mb-3">
          <label
            for="paquete"
            class="form-label"
          >Paquete</label>
          <input
            id="paquete"
            v-model="paquete"
            type="number"
            class="form-control"
            placeholder="Introduce el paquete"
          >
          <div
            v-if="errors.paquete"
            class="text-danger"
          >
            {{ errors.paquete }}
          </div>
        </div>
  
        <div class="mb-3">
          <label
            for="nombre_pagina"
            class="form-label"
          >Nombre de la Página</label>
          <input
            id="nombre_pagina"
            v-model="nombre_pagina"
            type="text"
            class="form-control"
            placeholder="Introduce el nombre de la página"
          >
          <div
            v-if="errors.nombre_pagina"
            class="text-danger"
          >
            {{ errors.nombre_pagina }}
          </div>
        </div>
  
        <div class="mb-3">
          <label
            for="correo"
            class="form-label"
          >Correo Electrónico</label>
          <input
            id="correo"
            v-model="correo_electronico"
            type="email"
            class="form-control"
            placeholder="Introduce tu correo"
          >
          <div
            v-if="errors.correo"
            class="text-danger"
          >
            {{ errors.correo }}
          </div>
        </div>
  
        <div class="mb-3">
          <label
            for="usuario"
            class="form-label"
          >Usuario</label>
          <input
            id="usuario"
            v-model="usuario"
            type="text"
            class="form-control"
            placeholder="Introduce el usuario"
          >
          <div
            v-if="errors.usuario"
            class="text-danger"
          >
            {{ errors.usuario }}
          </div>
        </div>
  
        <div class="mb-3">
          <label
            for="contrasena"
            class="form-label"
          >Contraseña</label>
          <input
            id="contrasena"
            v-model="contrasena"
            type="password"
            class="form-control"
            placeholder="Introduce la contraseña"
          >
          <div
            v-if="errors.contrasena"
            class="text-danger"
          >
            {{ errors.contrasena }}
          </div>
        </div>
  
        <button
          type="submit"
          class="btn btn-save w-100"
        >
          Guardar
        </button>
        <button
          type="button"
          class="btn btn-secondary w-100 mt-3"
          @click="goBack"
        >
          Regresar
        </button>
      </form>
  
      <p
        v-if="successMessage"
        class="text-success mt-3 text-center"
      >
        {{ successMessage }}
      </p>
      <p
        v-if="errorMessage"
        class="text-danger mt-3 text-center"
      >
        {{ errorMessage }}
      </p>
    </div>
  </div>
</template>
  
  <script>
  import axios from 'axios';
  import baseUrl from '../api'; // Asegúrate de que la ruta sea correcta
  
  export default {
    data() {
      return {
        nombre_festejada: '',
        apellido_festejada: '',
        fechaevento: '',
        telefono: '',
        estado: '',
        tipo_evento: '', // Campo nuevo
        paquete: '',
        nombre_pagina: '',
        correo_electronico: '',
        usuario: '',
        contrasena: '',
        successMessage: '',
        errorMessage: '',
        errors: {},
        estados: [ // Lista de estados de México
          'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche', 
          'Chiapas', 'Chihuahua', 'Coahuila', 'Colima', 'Durango', 'Guanajuato', 
          'Guerrero', 'Hidalgo', 'Jalisco', 'Estado de México', 'Michoacán', 
          'Morelos', 'Nayarit', 'Nuevo León', 'Oaxaca', 'Puebla', 'Querétaro', 
          'Quintana Roo', 'San Luis Potosí', 'Sinaloa', 'Sonora', 'Tabasco', 
          'Tamaulipas', 'Tlaxcala', 'Veracruz', 'Yucatán', 'Zacatecas'
        ]
      };
    },
    methods: {
      validateForm() {
        this.errors = {};
        let valid = true;
     
        // Validaciones
        if (!this.nombre_festejada) {
          this.errors.nombre = 'Este campo es requerido.';
          valid = false;
        }
        if (!this.apellido_festejada) {
          this.errors.apellido = 'Este campo es requerido.';
          valid = false;
        }
        if (!this.fechaevento) {
          this.errors.fechaevento = 'Este campo es requerido.';
          valid = false;
        }
        if (!this.telefono) {
          this.errors.telefono = 'Este campo es requerido.';
          valid = false;
        }
        if (!this.estado) {
          this.errors.estado = 'Este campo es requerido.';
          valid = false;
        }
        if (!this.tipo_evento) {
          this.errors.tipo_evento = 'Este campo es requerido.';
          valid = false;
        }
        if (!this.paquete) {
          this.errors.paquete = 'Este campo es requerido.';
          valid = false;
        }
        if (!this.nombre_pagina) {
          this.errors.nombre_pagina = 'Este campo es requerido.';
          valid = false;
        }
        if (!this.correo_electronico) {
          this.errors.correo = 'Este campo es requerido.';
          valid = false;
        }
        if (!this.usuario) {
          this.errors.usuario = 'Este campo es requerido.';
          valid = false;
        }
        if (!this.contrasena) {
          this.errors.contrasena = 'Este campo es requerido.';
          valid = false;
        }
  
        return valid;
      },    goBack() {
    this.$router.push('/'); // Asegúrate de que Vue Router esté configurado
  },
      async submitForm() {
        if (!this.validateForm()) {
          return; // Detener el envío si hay errores
        }
  
        const data = {
          nombre_festejada: this.nombre_festejada,
          apellido_festejada: this.apellido_festejada,
          fechaevento: this.fechaevento,
          telefono: this.telefono,
          estado: this.estado,
          tipo_evento: this.tipo_evento, // Agregar tipo de evento
          paquete: this.paquete,
          nombre_pagina: this.nombre_pagina,
          correo_electronico: this.correo_electronico,
          usuario: this.usuario,
          contrasena: this.contrasena // Envía la contraseña sin encriptar
        };
  
        try {
            const url = `${baseUrl}/api2/register`; // Verifica que baseUrl sea correcto
            const response = await axios.post(url, data);
            console.log(url);

          if (response.data.success) {
            this.successMessage = 'Datos guardados correctamente.';
            this.errorMessage = '';
            this.resetForm(); // Opcional: resetear el formulario
          } else {
            this.errorMessage = response.data.message;
            this.successMessage = '';
          }
        } catch (error) {
          this.errorMessage = 'Ocurrió un error al guardar los datos.';
          this.successMessage = '';
          console.error(error);
        }
      },
      resetForm() {
        this.nombre_festejada = '';
        this.apellido_festejada = '';
        this.fechaevento = '';
        this.telefono = '';
        this.estado = '';
        this.tipo_evento = ''; // Limpiar tipo de evento
        this.paquete = '';
        this.nombre_pagina = '';
        this.correo_electronico = '';
        this.usuario = '';
        this.contrasena = '';
        this.errors = {}; // Limpiar errores
      }
    }
  };
  </script>
  
  <style scoped>
  .form-container {
    width: 100%;
    max-width: 600px;
    margin: 80px auto;
    padding: 20px;
  }
  
  .card {
    background-color: white;
    color: #333;
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }
  
  h2 {
    color: #343a40;
  }
  
  .form-label {
    color: #495057;
  }
  
  .btn-save {
    background-color: #28a745; /* Color verde */
    color: white;
    border: none;
    transition: background-color 0.3s, transform 0.3s;
  }
  
  .btn-save:hover {
    background-color: #218838; /* Verde más oscuro al pasar el mouse */
    transform: scale(1.05);
  }
  
  .text-danger {
    font-size: 0.875rem; /* Tamaño de texto más pequeño para mensajes de error */
  }
  </style>
  